import React from 'react';
import PayPage from './components/PayPage.js';
import Verify from "./components/Verify.js";
import Page404 from './components/Page404.js';
import { Toaster } from 'react-hot-toast';
import { Routes, Route, Navigate } from "react-router-dom";

//functions 


const App = () => {



  return (
    <>

      <Routes>

        <Route path="/" element={<PayPage />} />
        <Route path="/verify" element={<Verify />} />
        <Route path='/*' element={<Page404 />} />


      </Routes>

      <div><Toaster /></div>

    </>
  );
};

export default App;